import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'El Protocolo de 15 Minutos',
    description: "La lista de pasos exactos para transformar tu sala de 'zona de guerra' a 'catálogo de revista'."
  }, {
    title: 'La Técnica de la Caja del Caos',
    description: 'Cómo hacer desaparecer el desorden físico en 120 segundos sin perder nada.'
  }, {
    title: 'Efecto Brillo de Hotel',
    description: 'Los 3 puntos estratégicos que deben reflejar luz para engañar al ojo humano.'
  }, {
    title: 'Aromaterapia de Supervivencia',
    description: "El truco del limón y la ventilación cruzada para que tu casa 'huela a nueva'."
  }, {
    title: 'Checklist SOS de Emergencia',
    description: 'Una hoja de ruta de un solo vistazo para los momentos de pánico absoluto.'
  }];
  return <section className="py-24 bg-white" data-id="element-22">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-900 mb-16" data-id="element-24">
          Lo que obtienes dentro del Blueprint
        </h2>

        <div className="space-y-6" data-id="element-25">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:border-orange-200 transition-colors" data-id="element-26">
              <CheckCircle2Icon className="w-8 h-8 text-orange-500 flex-shrink-0 mr-6" data-id="element-27" />
              <div data-id="element-28">
                <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-29">
                  {benefit.title}
                </h3>
                <p className="text-stone-600 text-lg" data-id="element-30">{benefit.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}